/**
 * Cart Tiered Rewards - Dynamic Progress Updates
 */

(function() {
  'use strict';

  const CartTieredRewards = {
    selectors: {
      component: '[data-cart-rewards]',
      progressBar: '[data-progress-bar]',
      message: '.cart-rewards__message p',
      icons: '.cart-rewards__icon'
    },

    init() {
      this.component = document.querySelector(this.selectors.component);
      
      if (!this.component) return;

      this.bindEvents();
    },

    bindEvents() {
      // Listen for Symmetry theme's cart change event
      document.addEventListener('on:cart:change', this.handleCartUpdate.bind(this));
      document.addEventListener('on:cart:error', this.handleCartUpdate.bind(this));
      document.addEventListener('on:cart:add', this.handleCartUpdate.bind(this));
    },

    handleCartUpdate: debounce(function() {
      fetch('/cart.js')
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(cart => {
          this.updateComponent(cart);
        })
        .catch(error => {
          console.error('Cart rewards update failed:', error);
        });
    }, 100),

    updateComponent(cart) {
      const currentQty = cart.item_count;
      
      const tier1Qty = parseInt(this.component.dataset.tier1Qty || 2);
      const tier1Label = this.component.dataset.tier1Label || '10% OFF';
      const tier2Qty = parseInt(this.component.dataset.tier2Qty || 3);
      const tier2Label = this.component.dataset.tier2Label || '15% OFF';
      const tier3Qty = parseInt(this.component.dataset.tier3Qty || 4);
      const tier3Label = this.component.dataset.tier3Label || '20% OFF';
      const maxTierQty = tier3Qty;

      const progressPercent = Math.min((currentQty / maxTierQty) * 100, 100);

      const progressBar = this.component.querySelector(this.selectors.progressBar);
      if (progressBar) {
        progressBar.style.width = `${progressPercent}%`;
      }

      this.updateMessage(currentQty, tier1Qty, tier1Label, tier2Qty, tier2Label, tier3Qty, tier3Label);
      this.updateIcons(currentQty, tier1Qty, tier2Qty, tier3Qty);

      this.component.dataset.currentQty = currentQty;

      if (currentQty === 0) {
        this.component.style.display = 'none';
      } else {
        this.component.style.display = 'block';
      }
    },

    updateMessage(currentQty, tier1Qty, tier1Label, tier2Qty, tier2Label, tier3Qty, tier3Label) {
      const messageElement = this.component.querySelector(this.selectors.message);
      if (!messageElement) return;

      const freeShipping = this.component.dataset.freeShipping === 'true';
      let message = '';
      let itemsNeeded = 0;
      let nextTierLabel = '';

      if (currentQty >= tier3Qty) {
        message = `🎉 <strong>Congratulations!</strong> You've unlocked <strong>${tier3Label}</strong>${freeShipping ? ' + <strong>FREE SHIPPING</strong>' : ''}`;
      } else if (currentQty >= tier2Qty) {
        itemsNeeded = tier3Qty - currentQty;
        nextTierLabel = tier3Label;
        message = `Add <strong>${itemsNeeded} more ${itemsNeeded === 1 ? 'item' : 'items'}</strong> and receive <strong>${nextTierLabel}</strong>`;
      } else if (currentQty >= tier1Qty) {
        itemsNeeded = tier2Qty - currentQty;
        nextTierLabel = tier2Label;
        message = `Add <strong>${itemsNeeded} more ${itemsNeeded === 1 ? 'item' : 'items'}</strong> and receive <strong>${nextTierLabel}</strong>`;
      } else {
        itemsNeeded = tier1Qty - currentQty;
        nextTierLabel = tier1Label;
        message = `Add <strong>${itemsNeeded} more ${itemsNeeded === 1 ? 'item' : 'items'}</strong> and receive <strong>${nextTierLabel}</strong>${freeShipping ? ' + <strong>FREE SHIPPING</strong>' : ''}`;
      }

      messageElement.innerHTML = message;
    },

    updateIcons(currentQty, tier1Qty, tier2Qty, tier3Qty) {
      const icons = this.component.querySelectorAll(this.selectors.icons);
      
      if (icons.length !== 3) return;

      // Tier 1
      if (currentQty >= tier1Qty) {
        icons[0].classList.add('cart-rewards__icon--fulfilled');
      } else {
        icons[0].classList.remove('cart-rewards__icon--fulfilled');
      }

      // Tier 2
      if (currentQty >= tier2Qty) {
        icons[1].classList.add('cart-rewards__icon--fulfilled');
      } else {
        icons[1].classList.remove('cart-rewards__icon--fulfilled');
      }

      // Tier 3
      if (currentQty >= tier3Qty) {
        icons[2].classList.add('cart-rewards__icon--fulfilled');
      } else {
        icons[2].classList.remove('cart-rewards__icon--fulfilled');
      }
    }
  };

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CartTieredRewards.init());
  } else {
    CartTieredRewards.init();
  }

  window.CartTieredRewards = CartTieredRewards;

})();